import { Component, inject, effect, input, output, computed, signal, Signal, DOCUMENT, PLATFORM_ID } from '@angular/core';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { auditTime, filter, throttleTime } from 'rxjs/operators';
import * as fromMenu from '@teamfoster/sdk/menu-ngrx';
import { toSignal } from '@angular/core/rxjs-interop';
import { LinkComponent } from '@teamfoster/sdk/button';
import { MagneticDirective } from 'src/app/shared/directives/magnetic.directive';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { isPlatformBrowser } from '@angular/common';
import { TrackLinkClickDirective } from 'src/app/shared/directives/track-link-click.directive';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  imports: [RouterModule, LinkComponent, MagneticDirective, TrackLinkClickDirective],
})
export class TopbarComponent {
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);

  loading = input<boolean>(false);
  menuActive = input<boolean>(false);
  logoClass = input<string>('');
  menu = input<fromMenu.MenuItem[]>([]);

  toggleOverlay = output<void>();
  closeOverlay = output<void>();
  openOverlay = output<void>();

  // normal items first, featured items last
  sortedMenu = computed(() => {
    return [...this.menu()].sort((a, b) => (a.featured === b.featured ? 0 : a.featured ? 1 : -1));
  });

  firstFeaturedItem = computed(() => {
    return this.sortedMenu().find(item => item.featured) ?? null;
  });

  private navigationStart$ = toSignal(this.router.events.pipe(filter(e => e instanceof NavigationStart)));

  routerEffect$ = effect(() => {
    const navigationStart = this.navigationStart$();

    if (this.menuActive()) {
      //this.closeOverlay.emit();
    }
  });

  scrollEvent = toSignal(
    fromEvent(this.document, 'scroll').pipe(
      throttleTime(100), // Emit the first event in the given time interval
      auditTime(100) // After the specified time, emit the last event observed
    )
  );

  lastScrollTop = 0;
  scrollDirection = signal<'up' | 'down'>('down');
  fixed = signal(false);
  collapsed = computed(() => this.scrollDirection() === 'down' && this.fixed());

  scrollEventEffect$ = effect(() => {
    const scrollEvent = this.scrollEvent();
    if (!isPlatformBrowser(this.platformId)) return;

    const st = window.scrollY > 0 ? window.scrollY : 0;
    const diff = Math.abs(st - this.lastScrollTop);
    if (diff < 60) {
      return; // Ignore small scrolls
    }
    this.scrollDirection.set(st < this.lastScrollTop ? 'up' : 'down');
    this.lastScrollTop = st;

    this.fixed.set(this.lastScrollTop > 50);
  });
}
